const useColors = ({ configuration }) => {
    return {
        primaryColor: configuration && configuration.primaryColor ?
            (configuration.primaryColor.includes("#")
                ? configuration.primaryColor
                : "#" + configuration.primaryColor)
            : "#000000",
        secondaryColor: configuration && configuration.secondaryColor ?
            (configuration.secondaryColor.includes("#")
                ? configuration.secondaryColor
                : "#" + configuration.secondaryColor)
            : "#000000",
    };
};

export default useColors;